export enum RatesheetValueTypes {
  Internal = 'INTERNAL',
  External = 'EXTERNAL',
  TCRoles = 'TC_ROLES',
  Tasks = 'TASKS',
  Expenses = 'EXPENSES',
  BudgetSplit = 'BUDGET_SPLIT',
  Services = 'SERVICES',
  Warehouse = 'WAREHOUSE',
  Transport = 'TRANSPORT',
  Materials = 'MATERIALS',
}
